module.exports = "/assets/8bb4a42e6f5107c02c3f739abc0b0e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/5T.png
// module id = 2201
// module chunks = 0